import React, { useEffect } from 'react';
import { css, keyframes } from '@emotion/react';

interface ToastProps {
  message: string;
  visible: boolean;
  onHide: () => void;
}

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(-10px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
`;

const toastContainerStyle = css`
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const toastStyle = css`
  padding: 8px 16px;
  animation: ${fadeInOut} 4s ease-in-out forwards;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  border-radius: 8px;
  background: var(--whiteA90, rgba(255, 255, 255, 0.9));
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);

  max-width: 90%;
  width: auto;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const StoryGameToast = ({ message, visible, onHide }: ToastProps) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onHide();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [visible, onHide]);

  if (!visible || !message) return null;

  return (
    <div css={toastContainerStyle}>
      <div css={toastStyle}>{message}</div>
    </div>
  );
};

export default StoryGameToast;
